import React, { Fragment } from 'react';
import matchSorter from 'match-sorter';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { formatDateDefault, formatDurationAsDaysHrsMins } from 'services/DateFormatters';
import { TIGHT_FIT_PARAM } from 'constants/System';

class ProjectIssueTable extends React.Component {
    constructor(props) {
        super(props);
        const { selected } = props;
        this.state = {
            selected
        };
    }
    render() {
        const { data, width, setProjectIssue } = this.props;
        const defaultWidth = width > TIGHT_FIT_PARAM ? 150 : 80;
        const styledSummaryColumn = (value) => {
            return <Fragment>
                <span className="d-inline-block text-black">
                    <div className="font-weight-bold">{value}</div>
                </span>
            </Fragment>;
        };

        const issueTypeColumn = {
            Header: 'Type',
            id: 'issuetype',
            accessor: d => d.fields?.issuetype?.name || 'unknown',
            filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, { keys: ['issuetype'] }),
            filterAll: true,
            width: defaultWidth,
        };
        const summaryColumn = {
            Header: 'Name',
            id: 'summary',
            accessor: d => d.fields?.summary,
            filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, { keys: ['summary'] }),
            Cell: ({ value }) => {
                return styledSummaryColumn(value);
            },
            filterAll: true,
        };
        const createdColumn = {
            Header: 'Start Date',
            id: 'created',
            accessor: d => d.fields?.created,
            filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, { keys: ['created'] }),
            filterAll: true,
            Cell: ({ value }) => {
                return formatDateDefault(value);
            },
            width: defaultWidth,
        };
        const resolvedColumn = {
            Header: 'Resolved Date',
            id: 'resolved',
            accessor: d => d.fields?.resolutiondate,
            filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, { keys: ['resolutiondate'] }),
            filterAll: true,
            Cell: ({ value }) => {
                return formatDateDefault(value);
            },
            width: defaultWidth,
        };
        const duration = {
            Header: 'Duration',
            accessor: d => d?.fields?.progress?.total,
            id: 'progress',
            Cell: ({ value }) => {
                return formatDurationAsDaysHrsMins(value);
            },
            width: defaultWidth,
        };
        const columnsList = new Array();
        columnsList.push(summaryColumn);
        columnsList.push(issueTypeColumn);
        columnsList.push(createdColumn);
        columnsList.push(resolvedColumn);
        if (width > TIGHT_FIT_PARAM) {
            columnsList.push(duration);
        }
        return (
            <div>
                <ReactTable
                    data={data}
                    filterable
                    defaultFilterMethod={(filter, row) =>
                        String(row[filter.id]) === filter.value}
                    columns={[
                        {
                            columns: columnsList
                        }
                    ]}
                    defaultPageSize={10}
                    className='-highlight'
                    getTrProps={(state, rowInfo) => {
                        if (rowInfo && rowInfo.row) {
                            return {
                                onClick: () => {
                                    console.log(JSON.stringify(rowInfo?.index));
                                    setProjectIssue(rowInfo?.original?.id);
                                    this.setState({
                                        selected: rowInfo.index
                                    });
                                },
                                style: {
                                    background: rowInfo.index === this.state.selected ? '#cfd8dc' : 'white',
                                    color: rowInfo.index === this.state.selected ? 'black' : 'black'
                                }
                            };
                        } else {
                            return {};
                        }
                    }}
                />
            </div>
        );
    }
}

export default ProjectIssueTable;


// WEBPACK FOOTER //
// ./components/Agile/projectIssue/projectIssueList/projectIssueTable/index.js